module.exports = __webpack_public_path__ + "img/a_apio.a3bf9ec1.svg";